export const PO_Box_Regex = /(?:Post[\s]*Office[\s]*?|P[.[\s]*]?O\.?)+[\s]*Box[\s]*#?/gim;
export const GPO_Box_Regex = /(?:General[\s]*Post[\s]*Office[\s]*?|G[.[\s]*]?P[.[\s]*]?O\.? )+[\s]*Box[\s]*#?/gim;
export const CARE_Box_Regex = /\b(?:care(?:\s*of)?|c\/\s*o)\s*[^\w]?s*po\b/i;
export const Private_Bag_Regex = /\bprivate\W*bag\b/i;
export const Locked_Bag_Regex = /\blocked\W*bag\b/i;

//TODO: Remove this as isPOBoxAddress is a clearer name just
//don't want to make too many changes with 26.5 coming closes.
export function isPostalAddress(value: string) {
  return isPOBoxAddress(value);
}

export function isPOBoxAddress(value: string) {
  const isPoBox = new RegExp(PO_Box_Regex).test(value);
  const isGpoBox = new RegExp(GPO_Box_Regex).test(value);
  const isCarePo = new RegExp(CARE_Box_Regex).test(value);
  const isPrivateBag = new RegExp(Private_Bag_Regex).test(value);
  const isLockedbag = new RegExp(Locked_Bag_Regex).test(value);

  return isPoBox || isGpoBox || isCarePo || isPrivateBag || isLockedbag;
}

export const Emoji_Regex = /\p{Extended_Pictographic}/gu;
export function emojiValidation({ value }: any) {
  return !value.match(Emoji_Regex)?.length;
}

// Convert 10 digit contact number to contact number with spaces
// Example: input of 0412345678 would output 0412 345 678
export const toSpacedContactNumber = (contactNumber: string) => {
  if (contactNumber && contactNumber.length === 10) {
    return contactNumber.replace(/(\d{4})(\d{3})(\d{3})/g, '$1 $2 $3');
  }

  return contactNumber;
};
